import usePageTitle from "@entrilia/shared/hooks/usePageTitle";
import adminApi from "../../../api/adminApi";
import EmailDeliveryLog from "./EmailDeliveryLog";

const InvestorEmailDeliveryLogPage = () => {
  usePageTitle("Email Delivery Log");

  return (
    <EmailDeliveryLog
      searchApi={adminApi.searchInvestorSentEmails}
      startExportApi={adminApi.startInvestorSentEmailsExport}
      getExportProgressApi={adminApi.getInvestorSentEmailsExportProgress}
    />
  );
};

export default InvestorEmailDeliveryLogPage;
